<template>
    <div class="tab-menu-wrap">
        <ul class="tab-menu">
            <li class="tab-menu__item active"><router-link to="/kr/mypage/favo/favoDoctors">관심 의료진</router-link></li>
            <li class="tab-menu__item"><router-link to="/kr/mypage/favo/favoContents">관심 콘텐츠</router-link></li>
        </ul>
    </div>
    <template v-if="doctorList.length == 0">
        <div class="emphasis">
            <div class="emphasis--icon">
                <img v-if="$store.state.hospStore.hostNm == '대동맥혈관병원'" src="/resource/icon/emphasis-icon01.svg" class="" alt="">
                <img v-else-if="$store.state.hospStore.hostNm == '뇌혈관병원'" src="/resource/icon/emphasis-icon01-brain.svg" class="" alt="">
                <img v-else-if="$store.state.hospStore.hostNm == '엄마아기병원'" src="/resource/icon/emphasis-icon01-mom.svg" class="" alt="">
                <img v-else-if="$store.state.hospStore.hostNm == '혈액암병원'" src="/resource/icon/emphasis-icon01-blood.svg" class="" alt="">
            </div>
            <h3 class="title02">
                "등록한 관심의료진이 없습니다."
            </h3>
        </div>
    </template>
    
    <kr_DoctorCard :doctorList="doctorList" @getList="getList" v-else/>
    

</template>

<script>
    export default {
        data() {
            return {
                doctorList: [],
            };
        },
        methods: {
            getList(){
                this.axios({
                    method:"get",
                    url: this.api.favorite.list, 
                    params:  { 'favoTypeCd' : 'DOCTOR' }
                }).then(res => {
                    this.doctorList = res.data.list
                });
            }
        },
        mounted() {
            this.getList()
        }
    };
</script>